import { render, staticRenderFns } from "./StatisticOverview.vue?vue&type=template&id=a79bedec&scoped=true"
import script from "./StatisticOverview.vue?vue&type=script&lang=js"
export * from "./StatisticOverview.vue?vue&type=script&lang=js"
import style0 from "./StatisticOverview.vue?vue&type=style&index=0&id=a79bedec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79bedec",
  null
  
)

export default component.exports